import { render, staticRenderFns } from "./m-dialog-info.vue?vue&type=template&id=51593b9a&scoped=true&lang=pug&"
import script from "./m-dialog-info.vue?vue&type=script&lang=js&"
export * from "./m-dialog-info.vue?vue&type=script&lang=js&"
import style0 from "./m-dialog-info.vue?vue&type=style&index=0&id=51593b9a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51593b9a",
  null
  
)

export default component.exports